/* AeroSims, Widerrufsfunktion /pages/withdraw (Art. 11a RL 2011/83/EU, § 356a BGB), 25.9.2026.
   Gehoert zu sections/as-withdraw.liquid. Quelle: recht_umsetzung/widerruf (daten/texte.mjs, bau.mjs).
   Schritt 1 Formular, Schritt 2 Zusammenfassung mit dem Knopf "Confirm withdrawal" (nur diese Worte),
   dann Eingangsseite. Gesendet wird erst beim Klick auf diesen Knopf.
   Als Theme-Datei mit defer, weil Inline-Skripte in diesem Theme nie laufen (#MainContent wird neu
   eingesetzt). Deshalb Ereignisdelegation am document und Elemente immer frisch per id suchen.
   Ohne JavaScript schickt das Formular an den Worker, der dieselben Schritte als eigene Seiten zeigt.
   Faellt fetch aus (Netz, Browser-Sperre), geht die schon bestaetigte Erklaerung als normales
   Formular an den Worker (Schritt 2): der Kunde landet auf dessen Eingangsseite. Kam die erste Anfrage doch an,
   erkennt der Worker die gleiche Erklaerung (24 Stunden) und bestaetigt sie nicht ein zweites Mal.
   Abschluss 25.9.2026: Honigtopf-Feld hp_x ohne Beschriftung, Freitext in ar/he isoliert, Steuerzeichen raus. */
(function () {
  if (window.__asWdGebunden) return;
  window.__asWdGebunden = true;

  var ZUSTAND = null;
  var SENDET = false;

  function $(id) { return document.getElementById(id); }
  function wurzel() { return $('asWd'); }
  function texte() {
    var el = $('asWdTexte');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }
  function fill(s, v) {
    return String(s == null ? '' : s).replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(v, k) ? String(v[k]) : m; });
  }
  // Isolierter Einschub: Datum, Uhrzeit, Referenz und Adresse bleiben in ar/he in Leserichtung geordnet.
  var FSI = String.fromCharCode(0x2068), PDI = String.fromCharCode(0x2069);
  function iso(x) { return FSI + String(x == null ? '' : x) + PDI; }
  function sauber(s, max) {
    return String(s == null ? '' : s).replace(/[\u0000-\u001f\u007f\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max);
  }
  // Gleiche Regel wie der Worker (widerrufErklaerung) und daten/texte.mjs (erklaerungText).
  function erklaerung(t, teil) {
    var d = String(teil || '').replace(/\s+/g, ' ').trim().replace(/[.。।]+$/, '');
    if (!d) d = t.dienst_alle;
    else if (t.dir === 'rtl') d = FSI + d + PDI;
    return t.erklaerung + t.sep + d + t.ende;
  }
  function orderNorm(s) {
    var r = String(s == null ? '' : s).replace(/[^A-Za-z0-9#-]/g, '').replace(/#/g, '').slice(0, 24);
    if (!r) return '';
    return /^\d+$/.test(r) ? '#' + r : r;
  }
  var EMAIL_RE = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:".]{2,}$/;

  function setzeFeld(bereich, name, wert) {
    var el = bereich && bereich.querySelector('[data-wd-feld="' + name + '"]');
    if (el) el.textContent = wert;
  }
  function zeigeFehler(inputId, fehlerId, text) {
    var inp = $(inputId), p = $(fehlerId);
    if (!inp || !p) return;
    if (text) { p.textContent = text; p.hidden = false; inp.setAttribute('aria-invalid', 'true'); }
    else { p.textContent = ''; p.hidden = true; inp.removeAttribute('aria-invalid'); }
  }
  function lesen(form) {
    var u = form.querySelector('input[name="umfang"]:checked');
    var umfang = u && u.value === 'teil' ? 'teil' : 'alles';
    return {
      lang: (wurzel() && wurzel().getAttribute('data-lang')) || 'en',
      name: sauber(form.elements.name && form.elements.name.value, 120),
      email: sauber(form.elements.email && form.elements.email.value, 254).replace(/\s/g, ''),
      order: orderNorm(form.elements.order && form.elements.order.value),
      umfang: umfang,
      teil: umfang === 'teil' ? sauber(form.elements.teil && form.elements.teil.value, 300) : '',
      hp_x: sauber(form.elements.hp_x && form.elements.hp_x.value, 200)
    };
  }
  function schritt(welcher) {
    var f = $('asWdForm'), p = $('asWdPruef'), o = $('asWdOk');
    if (f) f.hidden = welcher !== 'form';
    if (p) p.hidden = welcher !== 'pruef';
    if (o) o.hidden = welcher !== 'ok';
    var ziel = welcher === 'pruef' ? $('asWdPruefH') : (welcher === 'ok' ? $('asWdOkH') : $('asWdName'));
    if (ziel) {
      try { ziel.focus({ preventScroll: true }); } catch (e) { ziel.focus(); }
      var r = wurzel();
      if (r && r.scrollIntoView) { try { r.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { r.scrollIntoView(); } }
    }
  }
  function sendeFehler(text) {
    var p = $('asWdSendeFehler');
    if (!p) return;
    p.textContent = text || '';
    p.hidden = !text;
  }

  function weiter(form) {
    var t = texte();
    if (!t) { form.submit(); return; }
    var d = lesen(form);
    var fehlt = null;
    zeigeFehler('asWdName', 'asWdNameE', d.name ? '' : t.e_name);
    if (!d.name) fehlt = fehlt || 'asWdName';
    var mailOk = d.email.length <= 254 && EMAIL_RE.test(d.email);
    zeigeFehler('asWdEmail', 'asWdEmailE', mailOk ? '' : t.e_email);
    if (!mailOk) fehlt = fehlt || 'asWdEmail';
    var teilOk = d.umfang !== 'teil' || !!d.teil;
    zeigeFehler('asWdTeil', 'asWdTeilE', teilOk ? '' : t.e_teil);
    if (!teilOk) fehlt = fehlt || 'asWdTeil';
    if (fehlt) { var el = $(fehlt); if (el) el.focus(); return; }
    ZUSTAND = d;
    var p = $('asWdPruef');
    setzeFeld(p, 'inhalt', erklaerung(t, d.teil));
    setzeFeld(p, 'name', d.name);
    setzeFeld(p, 'email', d.email);
    setzeFeld(p, 'order', d.order || t.keine);
    sendeFehler('');
    schritt('pruef');
  }

  // Rueckfall: die bestaetigte Erklaerung als normales Formular an den Worker (Schritt 2).
  function alsFormular(d) {
    var r = wurzel();
    var ziel = (r && r.getAttribute('data-endpoint')) || '';
    if (!ziel) return false;
    var f = document.createElement('form');
    f.method = 'post'; f.action = ziel; f.style.display = 'none';
    var felder = { step: '2', lang: d.lang, name: d.name, email: d.email, order: d.order, umfang: d.umfang, teil: d.teil, hp_x: d.hp_x };
    Object.keys(felder).forEach(function (k) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = felder[k] || ''; f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
    return true;
  }

  function senden(knopf) {
    if (SENDET || !ZUSTAND) return;
    var t = texte() || {};
    var r = wurzel();
    var ziel = r && r.getAttribute('data-endpoint');
    if (!ziel) return;
    SENDET = true;
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    sendeFehler('');
    var d = ZUSTAND;
    var nutzlast = { bestaetigt: true, lang: d.lang, name: d.name, email: d.email, order: d.order, umfang: d.umfang, teil: d.teil, hp_x: d.hp_x };
    var fertig = function () { SENDET = false; knopf.disabled = false; knopf.removeAttribute('aria-busy'); };
    fetch(ziel, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(nutzlast), credentials: 'omit', cache: 'no-store' })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) { return { status: res.status, j: j || {} }; });
      })
      .then(function (a) {
        fertig();
        if (a.status === 200 && a.j.ok) {
          var o = $('asWdOk');
          /* 2.10.2026: Datum sprachrichtig aus dem Worker (datumText, zeitText, eingang); aeltere Antworten: ISO */
          setzeFeld(o, 'ok_text', fill(t.ok_text, { datum: iso(a.j.datumText || a.j.datum), zeit: iso(a.j.zeitText || a.j.zeit), ref: iso(a.j.ref) }));
          setzeFeld(o, 'ok_mail', fill(t.ok_mail, { email: iso(a.j.email) }));
          setzeFeld(o, 'r_inhalt', a.j.inhalt || '');
          setzeFeld(o, 'r_name', a.j.name || d.name);
          setzeFeld(o, 'r_email', a.j.email || d.email);
          setzeFeld(o, 'r_order', a.j.order || t.keine);
          setzeFeld(o, 'r_eingang', a.j.eingang || (a.j.datum + ' ' + a.j.zeit + ' UTC'));
          setzeFeld(o, 'r_ref', a.j.ref || '');
          ZUSTAND = null;
          var form = $('asWdForm'); if (form) form.reset();
          schritt('ok');
          return;
        }
        if (a.status === 429) { sendeFehler(t.zuviel); return; }
        if (a.status === 400 && a.j && a.j.grund === 'eingabe') { schritt('form'); var form2 = $('asWdForm'); if (form2) weiter(form2); return; }
        sendeFehler(t.fehler);
      })
      .catch(function () {
        // Netzfehler oder gesperrter Abruf: als Formular senden, sonst Hinweis mit support@.
        if (!alsFormular(d)) { fertig(); sendeFehler(t.fehler); }
      });
  }

  function vorbelegen() {
    var form = $('asWdForm');
    if (!form || form.getAttribute('data-wd-vorbelegt') === '1') return;
    form.setAttribute('data-wd-vorbelegt', '1');
    try {
      var u = new URL(window.location.href);
      var o = u.searchParams.get('order');
      if (o) {
        if (form.elements.order && !form.elements.order.value) form.elements.order.value = orderNorm(o);
        u.searchParams.delete('order');
        if (window.history && window.history.replaceState) window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash);
      }
    } catch (e) { /* alte Browser: ohne Vorbelegung */ }
  }

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.id !== 'asWdForm') return;
    ev.preventDefault();
    weiter(f);
  }, true);
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('[data-wd]') : null;
    if (!b || !wurzel() || !wurzel().contains(b)) return;
    var was = b.getAttribute('data-wd');
    if (was === 'senden') { ev.preventDefault(); senden(b); }
    else if (was === 'aendern') { ev.preventDefault(); sendeFehler(''); schritt('form'); }
  });
  document.addEventListener('input', function (ev) {
    var el = ev.target;
    if (!el || !el.id || el.id.indexOf('asWd') !== 0) return;
    if (el.getAttribute('aria-invalid') === 'true') zeigeFehler(el.id, el.id + 'E', '');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vorbelegen); else vorbelegen();
  window.addEventListener('pageshow', vorbelegen);
  document.addEventListener('shopify:section:load', function () { var f = $('asWdForm'); if (f) f.removeAttribute('data-wd-vorbelegt'); vorbelegen(); });
})();
